/**
 * Auth context fields for stock APIs (creator-scoped; created_by required on writes).
 * @param {{ account_id?: string, user_id?: string, role?: string }} session
 * @param {Record<string, unknown>} [extra]
 */
export function stockRequestBody(session, extra = {}) {
  return {
    account_id: session?.account_id,
    user_id: session?.user_id,
    role: session?.role,
    ...extra,
  };
}
